import { Injectable } from '@angular/core';
import { FspPremissesGridDto } from './fsp-premisses-grid-data-model';
import { GridDataService } from '../../../../gk-kendo';

@Injectable({
  providedIn: 'any',
})
export class FspPremissesGridDataService extends GridDataService<FspPremissesGridDto> {
  constructor() {
    super(undefined, 'GET');
  }
}
